import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { approvalAPI } from '../services/approvalApi';
import '../styles/Approval.css';

const ApprovalLogin = ({ onLogin }) => {
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();

  const handleGoogleLoginSuccess = async (credentialResponse) => {
    setLoading(true);
    setError('');
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      const googleUser = {
        email: decoded.email,
        name: decoded.name,
        googleId: decoded.sub,
        picture: decoded.picture
      };
      const response = await approvalAPI.login(googleUser);
      onLogin(response.data.user);
      navigate('/approval/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to login. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLoginError = () => {
    setError('Google login failed. Please try again.');
  };

  return (
    <div className="approval-login">
      <div className="approval-login-box">
        <div className="approval-login-logo">
          <img src="/school.png" alt="Hope Haven Christian School" />
        </div>
        <h1>Approval &amp; Sign-off System</h1>
        <p className="approval-login-sub">
          Submit requests to your Head of Department, track approvals, and access signed documents.
        </p>
        {error && <div className="approval-error">{error}</div>}
        <div className="approval-google-btn">
          {loading ? (
            <div className="approval-loading-text">Signing in...</div>
          ) : (
            <GoogleLogin
              onSuccess={handleGoogleLoginSuccess}
              onError={handleGoogleLoginError}
              text="signin_with"
              size="large"
              theme="outline"
            />
          )}
        </div>
        <p className="approval-login-note">
          Access is limited to registered staff with @hopehavenschool.org email.
        </p>
      </div>
    </div>
  );
};

export default ApprovalLogin;
